<div class="app-container">
  <page-header [title]="'page.not-found.title'" [icon]="'fa-times'" [fullWidthPageTitle]="true"></page-header>

  <section class="content">
    <div>{{'page.not-found.description' | translate}}</div>
  </section>
</div>
